<template>
    <div class="banner d-flex justify-content-center align-items-center px-2">
        <div class="text-center">
            <h1 class="hero-text font-gothic-cond"> Home is where the Wifi connects</h1>
            <p class="fw-normal hero-caption font-gothic"> Discover properties to rent and <br /> live
                effortlessly</p>
            <div class="d-flex flex-row justify-content-center align-items-center">                
                <google-autocomplete name="home-hero" @place-changed="handlePlaceChanged"></google-autocomplete>
            </div>            
        </div>
    </div>
</template>

<script>
import GoogleAutocomplete from '@/components/shared/google-autocomplete.vue';

export default {
    name: 'home-hero',
    components: {
        GoogleAutocomplete
    },
    data: () => {
        return {
            city: 'all',
            searchQuery: '',
            googleMapsAvailable: false,
            cityCordinates: {
                latitude: 0,
                longitude: 0
            }
        };
    },
    methods: {
        handlePlaceChanged(placeData) {           
            this.city = placeData.city;
            this.cityCordinates.latitude = placeData.latitude;
            this.cityCordinates.longitude = placeData.longitude;
            this.navigateToSearch(this.city);
        },
        navigateToSearch(city) {
            const params = {
                city: encodeURI(city.replace("/", "-").toLowerCase()),
                longitude: this.cityCordinates.longitude,
                latitude: this.cityCordinates.latitude
            };
            this.$router.push({ name: 'search-results', params: params });
        }
    },
}
</script>

<style scoped>
.banner {
    margin-bottom: 30px;
    background: url('@/assets/images/Animation.gif') no-repeat center;
    background-size: cover;
    height: 80vh;
}

.banner .hero-text {
    font-size: 60px;
    color: #000000;
}

.banner .hero-caption {
    font-size: 20px;
    color: #7B7B7B;
}

.banner .banner-button {
    background-color: #E31662;
    color: #fff;
    padding: 10px 30px 10px 30px;
    font-size: 1rem;
}

/* Extra large devices (large desktops, 1200px and down) */
@media (max-width: 1200px) {
    .banner .hero-text {
        font-size: 40px;
    }

    .banner .hero-caption {
        font-size: 18px;
    }
}

/* Large devices (desktops, 992px and down) */
@media (max-width: 992px) {
    .banner {
        height: 60vh;
    }

    .banner .hero-text {
        font-size: 32px;
    }

    .banner .hero-caption {
        font-size: 16px;
    }
}

/* Medium devices (tablets, 768px and down) */
@media (max-width: 768px) {
    .banner {
        height: 50vh;
        padding: 20px 0;
    }

    .banner .hero-text {
        font-size: 30px;
    }

    .banner .hero-caption {
        font-size: 15px;
    }
}

/* Small devices (phones, 576px and down) */
@media (max-width: 576px) {
    .banner {
        height: 50vh;
        padding: 10px 0;
    }

    .banner .hero-text {
        font-size: 26px;
    }

    .banner .hero-caption {
        font-size: 14px;
    }
}
</style>
